import AllTaskView from "@/components/AllTasksView/allTasksView.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import { Card } from "@/shadcn/components/ui/card";

const TasksPage = () => {
  return (
    <BasePage currPage="tasks">
      <Card className="flex flex-col w-full h-full rounded-sm dark:bg-background ">
        <AllTaskView />
      </Card>
    </BasePage>
  );
};

export default TasksPage;
